export default __webpack_public_path__ + "static/media/vessels_closed_sales_ocean.03be367c.svg";